import React from "react";
import { Link } from "react-router-dom";
import { Gift, MessageCircle, Ticket, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import ReferEarnSection from "@/components/ReferEarnSection";
import SEOHead from "@/components/SEOHead";

const FAQS = [
  { q: "Where do I find my referral link?", a: "Complete any application and pay — your personal link appears on your tracking page (Track Application) and on the payment success screen, ready to copy or share on WhatsApp." },
  { q: "How does my friend get the discount?", a: "When they open your link, the discount is applied automatically at checkout on their first application. They can also type your referral code manually in the 'Referral / Coupon Code' field." },
  { q: "When do I receive my reward coupon?", a: "The moment your friend's payment succeeds, a coupon code is sent to you on WhatsApp (and email if provided). It also appears on the My Coupons page." },
  { q: "How do I use a coupon?", a: "Enter the coupon code in the 'Referral / Coupon Code' field on any application form — the discount applies instantly at checkout. If you type your WhatsApp number first, we'll even suggest your best unused coupon automatically." },
  { q: "Is there a limit on referrals?", a: "No — you earn a coupon for every friend who pays. Refer 10 friends, earn 10 coupons." },
];

export default function ReferEarn() {
  return (
    <div data-testid="refer-earn-page">
      <SEOHead pageKey="refer-and-earn" />
      <div className="bg-[#FAF8F4] py-14 sm:py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#b1976b]/15 mb-4">
            <Gift size={30} className="text-[#b1976b]" />
          </div>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-[#1A1A1A] mb-4">Refer &amp; Earn</h1>
          <p className="text-base text-[#54595f] max-w-2xl mx-auto leading-relaxed">
            Share Gulfudaan with friends heading to the Gulf — they save on their first application, and you earn a reward coupon every single time one of them pays. No sign-up, no forms, just your link.
          </p>
        </div>
      </div>
      <ReferEarnSection />
      <div className="bg-white py-14 sm:py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-lg text-[#1A1A1A] mb-6 flex items-center gap-2">
            <HelpCircle size={18} className="text-[var(--brand-primary)]" /> Frequently Asked Questions
          </h2>
          <div className="space-y-4" data-testid="refer-earn-faqs">
            {FAQS.map((f) => (
              <div key={f.q} className="rounded-lg border border-[#E5E1DA] bg-[#FAF8F4] p-5">
                <p className="font-heading font-bold text-[15px] text-[#1A1A1A] mb-1.5">{f.q}</p>
                <p className="text-sm text-[#54595f] leading-relaxed">{f.a}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/track">
              <Button data-testid="refer-earn-page-track-btn" className="bg-[var(--brand-primary)] hover:bg-[#9E855A] text-white h-11 px-6">
                <MessageCircle size={15} className="mr-2" /> Get My Referral Link
              </Button>
            </Link>
            <Link to="/my-coupons">
              <Button data-testid="refer-earn-page-coupons-btn" variant="outline" className="border-[var(--brand-primary)] text-[var(--brand-primary)] h-11 px-6">
                <Ticket size={15} className="mr-2" /> View My Coupons
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
